import { render } from "./Theaters.vue?vue&type=template&id=95929776&scoped=true&lang=true"
import script from "./Theaters.vue?vue&type=script&lang=js"
export * from "./Theaters.vue?vue&type=script&lang=js"

import "./Theaters.vue?vue&type=style&index=0&id=95929776&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95929776"]])

export default __exports__